import FrameworkUtils from 'utils/framework';
import { Image, Flex, Box } from 'components/ui';
import {
    space, fontSizes, fontWeights, mediaQueries
} from 'style/config';

import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import { useEffect, useRef, useState } from 'react';
import Location from 'utils/Location';

const { wrapFunctionalComponent } = FrameworkUtils;

function MinimizedSuperChat(props) {
    const aiBeautyChatRef = useRef(null);
    const {
        showSuperChat, localization, session, config, show, location
    } = props;
    const [loading, setLoading] = useState(true);

    const basketCheckoutHeightSmui = isBasketPage => {
        const dataHeightKey = isBasketPage ? 'bottomCostsummaryHeight' : 'bottomStickyHeight';

        return document.body.querySelector(`[data-height="${dataHeightKey}"]`)?.clientHeight || 0;
    };

    const updateOffset = element => {
        if (!element) {
            return;
        }

        requestAnimationFrame(() => {
            const isBasketPage = Location.isBasketPage();
            const height = basketCheckoutHeightSmui(isBasketPage);

            element.style.setProperty('--custom-bottom-offset', `calc(var(--bottomNavHeight, 0px) + ${height + space[3]}px)`);
            setLoading(false);
        });
    };

    const setRef = element => {
        aiBeautyChatRef.current = element;

        if (element) {
            updateOffset(element);
        }
    };

    useEffect(() => {
        if (aiBeautyChatRef.current) {
            updateOffset(aiBeautyChatRef.current);
        }
    }, [session, location]);

    if (showSuperChat || !session || !show) {
        return null;
    }

    const sendAnalytics = () => {
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data: {
                pageName: `${anaConsts.SUPER_CHAT.SUPERCHAT_LANDING}`,
                navigationInfo: `bottom nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat` // eVar64
            }
        });
    };

    const openSuperChat = () => {
        sendAnalytics();

        // Create a copy of the session without selectedPrompt to prevent auto-sending on reinitialization
        const sessionWithoutPrompt = { ...session };
        delete sessionWithoutPrompt.selectedPrompt;

        props.openSuperChat(sessionWithoutPrompt);
    };

    return (
        <Flex
            css={styles.floatingContainer}
            onClick={openSuperChat}
            className='multi-chat-active'
            ref={setRef}
            display={loading ? 'none' : 'flex'}
        >
            <Image
                disableLazyLoad={true}
                alt={config?.meta?.bot_name || localization.title}
                src={'/img/ufe/ai/ai_chat_white.svg'}
                width={26}
                height={26}
                css={styles.chatImg}
            />
            <Box css={styles.chatText}>{config?.meta?.bot_name || localization.title}</Box>
            <Flex
                width={24}
                alignItems='center'
                justifyContent='center'
                css={styles.chevronIcon}
            >
                <Image
                    disableLazyLoad={true}
                    alt='Up Chevron'
                    src={'/img/ufe/ai/minimized-super-chat/up-chevron.svg'}
                    width='1em'
                    height='1em'
                />
            </Flex>
        </Flex>
    );
}

const styles = {
    floatingContainer: {
        [mediaQueries.mdMax]: {
            bottom: 'var(--custom-bottom-offset)',
            width: 'auto',
            padding: space[3]
        },
        position: 'fixed',
        bottom: space[3],
        right: space[3],
        width: 258,
        height: 48,
        backgroundColor: 'black',
        borderRadius: 100,
        zIndex: 1000,
        padding: `${space[3]}px ${space[4]}px`,
        gap: space[2],
        alignItems: 'center',
        transition: 'bottom 0.3s ease-in-out'
    },
    chatText: {
        [mediaQueries.smMax]: {
            display: 'none'
        },
        color: 'white',
        fontSize: fontSizes.md,
        fontWeight: fontWeights.bold,
        flex: 1
    },
    chevronIcon: {
        [mediaQueries.smMax]: {
            display: 'none'
        }
    }
};

export default wrapFunctionalComponent(MinimizedSuperChat, 'MinimizedSuperChat');
